import { compose, pure } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import { NAME, ID } from './properties';
import ContentBox from './ContentBox';

export default compose(
  pure(),
  widget(
    { name: NAME, category: 'Text', componentId: ID },
    {
      defaults: {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: [
                'Packing tape trailer hitch rent truck certified dealer.',
                'Large aisle ground floor park here. 24-hour access for your crates. Closet space',
                'room in your driveway. Your document storage safe clean happy secure. Priceless',
                'family keepsakes grandmother\'s ashes. Surveillance resident manager free lock with unit.',
                'Self storage self storage self storage facility unit garage shelf attic space. Call us',
                'today solution packrat hoarders rejoice!',
              ].join(' '),
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      },
    },
  ),
)(ContentBox);
